module.exports = __webpack_public_path__ + "img/titleen.462b7951.png";